/* ==========================================================================
   Theme Controller - Iconsax Keyline Style
   ========================================================================== */

const STORAGE_KEY = 'theme';

export type Theme = 'light' | 'dark';

export function getSavedTheme(): Theme {
  let saved = 'dark';
  try {
    saved = localStorage.getItem(STORAGE_KEY) || 'dark';
  } catch {
    saved = 'dark';
  }
  return (saved === 'light' ? 'light' : 'dark');
}

export function applyTheme(theme: Theme): void {
  document.documentElement.setAttribute('data-theme', theme);
  const bgColor = theme === 'dark' ? '#0A0D14' : '#F5F7FB';
  document.documentElement.style.backgroundColor = bgColor;
  if (document.body) {
    document.body.style.backgroundColor = bgColor;
  }
  try {
    localStorage.setItem(STORAGE_KEY, theme);
  } catch {}
  
  const icon = document.getElementById('theme-icon');
  if (icon) {
    icon.textContent = theme === 'dark' ? '☀️' : '🌙';
  }
}

export function initThemeController(buttonSelector: string = '.btn-theme'): {
  toggleTheme: () => Theme;
  getTheme: () => Theme;
} {
  const currentTheme = getSavedTheme();
  applyTheme(currentTheme);

  const toggleBtn = document.querySelector<HTMLButtonElement>(buttonSelector);

  const toggleTheme = (): Theme => {
    const nextTheme: Theme = document.documentElement.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
    applyTheme(nextTheme);
    return nextTheme;
  };

  if (toggleBtn) {
    toggleBtn.addEventListener('click', () => {
      toggleTheme();
    });
  }

  return {
    toggleTheme,
    getTheme: () => (document.documentElement.getAttribute('data-theme') as Theme) || 'light'
  };
}
